const clearDisabledFormButton = (element) => {
  element.addEventListener('error', (event) => {
    if (event.detail?.name === 'InvalidStateError') {
      window.showError('このパスキーはすでに登録済みです。');
    }
    const form = element.closest('form');
    if (form) {
      const submitButton = form.querySelector('input[type="submit"]');
      if (submitButton) {
        submitButton.disabled = false;
      }
    }
  });
}
document.addEventListener('turbo:load', () => {
  const webauthnLogin = document.querySelector('webauthn-login');
  if (webauthnLogin) {
    clearDisabledFormButton(webauthnLogin);
  }

  const webauthnRegister = document.querySelector('webauthn-registration');
  if (webauthnRegister) {
    clearDisabledFormButton(webauthnRegister);
  }
});
